import { useEffect, useRef, useSyncExternalStore } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import styles from './ImpersonationBanner.module.scss'

import { getImpersonation, setImpersonation, subscribeImpersonation } from '@/lib/impersonation'
import { AppDispatch } from '@/store'
import { getEnterpriseThunk } from '@/store/features/user/userSlice'
import { resetTenantState } from '@/store/resetTenantState'

const ImpersonationBanner = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const impersonating = useSyncExternalStore(subscribeImpersonation, getImpersonation)
  const prevImpersonating = useRef(impersonating)

  // Handle any transition from impersonating → null (manual Stop or timeout expiry)
  useEffect(() => {
    const wasImpersonating = prevImpersonating.current
    prevImpersonating.current = impersonating

    if (wasImpersonating && !impersonating) {
      resetTenantState(dispatch, 'enterprise')
      dispatch(getEnterpriseThunk({ needSubscription: false }))
        .unwrap()
        .then(() => navigate('/app/enterprises/manage'))
        .catch(() => navigate('/app/enterprises/manage'))
    }
  }, [impersonating, dispatch, navigate])

  if (!impersonating) return null

  const handleStop = () => {
    setImpersonation(null)
  }

  return (
    <div className={styles.banner}>
      <span>Viewing {impersonating.enterpriseName}</span>
      <button onClick={handleStop} className={styles.stopButton}>
        Stop
      </button>
    </div>
  )
}

export default ImpersonationBanner
